import $dayjs from '@/utils/dayjs';
import { isUndefined } from '../isUndefined';

const dateValidator = (val: string) => {
    if (isUndefined(val)) {
        return { hasError: false };
    }

    return {
        hasError: !$dayjs(val, 'DD/MM/YYYY', true).isValid(),
        message:
            'Gegeven is niet een valide datum, gewenste notatie: dd/mm/jjjj',
    };
};

export default dateValidator;
